var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGearCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24394",
    "data-name": "Group 24394",
    transform: "translate(-1137.1 -484.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_44873867-young-executive-business-woman-success-and-education-background-",
    "data-name": "44873867-young-executive-business-woman-success-and-education-background-",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(1137.1 484.5)",
    fill: "#243844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_004-settings",
    "data-name": "004-settings",
    d: "M17.164,7.108l-1.423-.181a7.151,7.151,0,0,0-.431-1.04l.879-1.131a1.125,1.125,0,0,0-.092-1.5L14.906,2.067a1.128,1.128,0,0,0-1.5-.1l-1.13.879a7.125,7.125,0,0,0-1.04-.431L11.052,1A1.133,1.133,0,0,0,9.928,0h-1.7A1.133,1.133,0,0,0,7.108,1L6.928,2.419a7.043,7.043,0,0,0-1.04.431L4.757,1.971a1.126,1.126,0,0,0-1.5.092L2.067,3.255a1.128,1.128,0,0,0-.1,1.5L2.85,5.888a7.068,7.068,0,0,0-.431,1.04L1,7.108A1.133,1.133,0,0,0,0,8.233v1.7a1.133,1.133,0,0,0,1,1.124l1.423.181a7.151,7.151,0,0,0,.431,1.04L1.971,13.4a1.125,1.125,0,0,0,.092,1.5l1.192,1.192a1.129,1.129,0,0,0,1.5.1l1.131-.879a6.986,6.986,0,0,0,1.04.431l.181,1.42a1.133,1.133,0,0,0,1.124,1h1.7a1.133,1.133,0,0,0,1.124-1l.181-1.423a7.151,7.151,0,0,0,1.04-.431l1.131.879a1.125,1.125,0,0,0,1.5-.092l1.192-1.192a1.127,1.127,0,0,0,.1-1.5l-.879-1.131a6.986,6.986,0,0,0,.431-1.04l1.42-.181a1.133,1.133,0,0,0,1-1.124v-1.7a1.132,1.132,0,0,0-1-1.124ZM9.08,12.864A3.784,3.784,0,1,1,12.864,9.08,3.788,3.788,0,0,1,9.08,12.864Z",
    transform: "translate(1148.02 495.42)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearCircle);
export default __webpack_public_path__ + "static/media/gear_circle.081245d0194daad0abe52f0d9e13794a.svg";
export { ForwardRef as ReactComponent };